import type { RootState } from '../store';

export const selectUser = (state: RootState) => state.user.data;
export const selectUserLoading = (state: RootState) => state.user.loading;
export const selectUserError = (state: RootState) => state.user.error;
export const selectIsPublishingBlocked = (state: RootState) =>
  state.user.data?.isPublishingBlocked ?? false;
export const selectCanRedeemDomainVoucher = (state: RootState) =>
  state.user.data?.canRedeemDomainVoucher ?? false;
export const selectMaxDomains = (state: RootState) => state.user.data?.maxDomains ?? 0;

export const selectUserAccessId = (state: RootState): string | null => {
  const user = state.user.data;
  const profiles = user?.active_user?.profiles ?? user?.profiles;
  if (!profiles) return null;
  const baseProfile = profiles.BASE_20160216;
  if (typeof baseProfile?.accessId === 'string') return baseProfile.accessId;
  const profileValues = Object.values(profiles);
  const firstProfileWithAccessId = profileValues.find(
    (profile) => typeof profile.accessId === 'string',
  );
  return firstProfileWithAccessId?.accessId ?? null;
};
